import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { IResponse } from "./response.model";
import { PaginatedResponse } from "./pagination.model";
import { TemplateApiService } from "./template-api.service";


export interface ICliente extends IResponse {
    ativo: boolean,
    data_criacao: string,
    tipo: string
}

@Injectable()
export class AdmEquipeService extends TemplateApiService<ICliente> {

    private clienteId: string | null = null;

    public override setBaseUrl(idCliente: string) {
        this.clienteId = idCliente;
        this.baseUrl = `admin/acessos-clientes/${idCliente}/equipes`;
    }

    /**
     * Só lista as equipes quando um cliente estiver selecionado. Enquanto não
     * houver cliente (ex.: na inicialização da tela de licenças), retorna uma
     * listagem vazia sem disparar requisição.
     */
    public override get(params: any = {}): Observable<PaginatedResponse<ICliente>> {
        if (!this.clienteId) {
            return of({
                pagina: 1,
                total: 0,
                'total-paginas': 0,
                resultados: []
            } as PaginatedResponse<ICliente>);
        }

        return super.get(params);
    }
}
